import React, {useState} from "react";
import "./FundingSection.scss";

import PlansSection from "../PlansSection/PlansSection";

const FundingSection = ({selectedPlanId, handleScrollToCheckout, apiData, isLoading}) => {
  return (
    <>
      <div className="fundingSectionContainer">
        <div className="fundingSectionWrapper">
          <PlansSection
            selectedPlanId={selectedPlanId}
            handleScrollToCheckout={handleScrollToCheckout}
            apiData={apiData}
            isLoading={isLoading}
          />
        </div>
      </div>
    </>
  );
};

export default FundingSection;
